import type { SVGProps } from "react";
import * as React from "react";
import { type iconSize, iconSizeVariants } from "@remi/types/icons";

type SvgIconProps = SVGProps<SVGSVGElement> & {
  size?: iconSize;
};
const Sun4pm = ({ size = "sm", ...props }: SvgIconProps) => {
  props.width = iconSizeVariants[size];
  props.height = iconSizeVariants[size];
  return (
    <svg {...props} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8 1.31604C7.65482 1.31604 7.375 1.59586 7.375 1.94104V3.05903C7.375 3.40421 7.65482 3.68403 8 3.68403C8.34518 3.68403 8.625 3.40421 8.625 3.05903V1.94104C8.625 1.59586 8.34518 1.31604 8 1.31604Z"
        fill="currentColor"
      />
      <path
        d="M8 12.316C7.65482 12.316 7.375 12.5959 7.375 12.941V14.059C7.375 14.4042 7.65482 14.684 8 14.684C8.34518 14.684 8.625 14.4042 8.625 14.059V12.941C8.625 12.5959 8.34518 12.316 8 12.316Z"
        fill="currentColor"
      />
      <path
        d="M1.31604 8C1.31604 8.34518 1.59586 8.625 1.94104 8.625H3.05903C3.40421 8.625 3.68403 8.34518 3.68403 8C3.68403 7.65482 3.40421 7.375 3.05903 7.375H1.94104C1.59586 7.375 1.31604 7.65482 1.31604 8Z"
        fill="currentColor"
      />
      <path
        d="M12.316 8C12.316 8.34518 12.5959 8.625 12.941 8.625H14.059C14.4042 8.625 14.684 8.34518 14.684 8C14.684 7.65482 14.4042 7.375 14.059 7.375H12.941C12.5959 7.375 12.316 7.65482 12.316 8Z"
        fill="currentColor"
      />
      <path
        d="M3.27376 3.27376C3.02968 3.51784 3.02968 3.91357 3.27376 4.15764L4.0643 4.94818C4.30837 5.19226 4.7041 5.19226 4.94818 4.94818C5.19226 4.7041 5.19226 4.30838 4.94818 4.0643L4.15764 3.27376C3.91356 3.02968 3.51783 3.02968 3.27376 3.27376Z"
        fill="currentColor"
      />
      <path
        d="M11.0518 11.052C10.8078 11.296 10.8078 11.6918 11.0518 11.9358L11.8424 12.7264C12.0864 12.9705 12.4822 12.9705 12.7263 12.7264C12.9703 12.4823 12.9703 12.0866 12.7263 11.8425L11.9357 11.052C11.6916 10.8079 11.2959 10.8079 11.0518 11.052Z"
        fill="currentColor"
      />
      <path
        d="M3.27373 12.7264C3.51781 12.9704 3.91353 12.9704 4.15761 12.7264L4.94815 11.9358C5.19223 11.6917 5.19223 11.296 4.94815 11.0519C4.70407 10.8079 4.30835 10.8079 4.06427 11.0519L3.27373 11.8425C3.02965 12.0866 3.02965 12.4823 3.27373 12.7264Z"
        fill="currentColor"
      />
      <path
        d="M11.0518 4.94817C11.2959 5.19225 11.6916 5.19225 11.9357 4.94817L12.7262 4.15763C12.9703 3.91355 12.9703 3.51782 12.7262 3.27374C12.4822 3.02967 12.0864 3.02967 11.8423 3.27374L11.0518 4.06428C10.8077 4.30836 10.8077 4.70409 11.0518 4.94817Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.4824 9.08496C4.94539 10.5878 6.34508 11.6801 7.99987 11.6801C10.0323 11.6801 11.6799 10.0325 11.6799 8.00007C11.6799 5.96766 10.0323 4.32007 7.99987 4.32007C6.34419 4.32007 4.94389 5.41347 4.48166 6.91759C4.37787 7.24589 4.31982 7.61286 4.31982 8.0001C4.31982 8.38826 4.37815 8.75606 4.4824 9.08496ZM7.99987 10.4301C7.60323 10.4301 7.22878 10.335 6.89806 10.1665C7.3861 9.72121 7.71191 8.91755 7.71191 8.0001C7.71191 7.08263 7.38608 6.27894 6.89801 5.83366C7.22875 5.66511 7.60321 5.57007 7.99987 5.57007C9.34192 5.57007 10.4299 6.65802 10.4299 8.00007C10.4299 9.34212 9.34192 10.4301 7.99987 10.4301Z"
        fill="currentColor"
      />
    </svg>
  );
};
export default Sun4pm;
